import { CategoryViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';

export type Category = z.infer<typeof CategoryViewSchema>;

export const StoreCategorySchema = z.object({
  title: z.string().min(1, { message: 'validation.required' }).max(255),
  description: z.string().nullable().optional(),
  contingent_id: z
    .number()
    .int()
    .min(1, { message: 'validation.required' }),
});

export type StoreCategoryPayload = z.infer<typeof StoreCategorySchema>;
export const UpdateCategorySchema = StoreCategorySchema.partial();
export type UpdateCategoryPayload = z.infer<typeof UpdateCategorySchema>;

export const categoryTranslations = _([
  'catalog.categories.title',
  'catalog.categories.add',
  'catalog.categories.edit',
  'catalog.categories.deleteConfirmHeader',
  'catalog.categories.deleteConfirmMessage',
  'catalog.categories.created',
  'catalog.categories.updated',
  'catalog.categories.deleted',
  'catalog.categories.loadError',
  'catalog.categories.createError',
  'catalog.categories.updateError',
  'catalog.categories.deleteError',
  'catalog.categories.fields.title',
  'catalog.categories.fields.description',
  'catalog.categories.fields.contingent',
  'catalog.categories.fields.contingentPlaceholder',
]);
